function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var t = /*#__PURE__*/function (_Date) {
  _inherits(t, _Date);

  var _super = _createSuper(t);

  function t() {
    var _temp, _this;

    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";

    _classCallCheck(this, t);

    (_temp = _this = _super.call(this, t.parseDateTime(e, i, n)), _this.lang = void 0, _temp), _this.lang = n;
    return _this;
  }

  _createClass(t, [{
    key: "getWeek",
    value: function getWeek(_t3) {
      var e = new Date(this.midnight_ts(this)),
          i = (this.getDay() + (7 - _t3)) % 7;
      e.setDate(e.getDate() - i);
      var n = e.getTime();
      return e.setMonth(0, 1), e.getDay() !== _t3 && e.setMonth(0, 1 + (4 - e.getDay() + 7) % 7), 1 + Math.ceil((n - e.getTime()) / 6048e5);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new t(this);
    }
  }, {
    key: "toJSDate",
    value: function toJSDate() {
      return new Date(this);
    }
  }, {
    key: "inArray",
    value: function inArray(_t4) {
      var _this2 = this;

      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "[]";
      return _t4.some(function (_t5) {
        return _t5 instanceof Array ? _this2.isBetween(_t5[0], _t5[1], e) : _this2.isSame(_t5, "day");
      });
    }
  }, {
    key: "isBetween",
    value: function isBetween(_t6, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "()";

      switch (i) {
        default:
        case "()":
          return this.midnight_ts(this) > this.midnight_ts(_t6) && this.midnight_ts(this) < this.midnight_ts(e);

        case "[)":
          return this.midnight_ts(this) >= this.midnight_ts(_t6) && this.midnight_ts(this) < this.midnight_ts(e);

        case "(]":
          return this.midnight_ts(this) > this.midnight_ts(_t6) && this.midnight_ts(this) <= this.midnight_ts(e);

        case "[]":
          return this.midnight_ts() >= this.midnight_ts(_t6) && this.midnight_ts() <= this.midnight_ts(e);
      }
    }
  }, {
    key: "isBefore",
    value: function isBefore(_t7) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(_t7.getFullYear(), _t7.getMonth(), _t7.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

        case "month":
        case "months":
          return new Date(_t7.getFullYear(), _t7.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();

        case "year":
        case "years":
          return _t7.getFullYear() > this.getFullYear();
      }

      throw new Error("isBefore: Invalid unit!");
    }
  }, {
    key: "isSameOrBefore",
    value: function isSameOrBefore(_t8) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(_t8.getFullYear(), _t8.getMonth(), _t8.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();

        case "month":
        case "months":
          return new Date(_t8.getFullYear(), _t8.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
      }

      throw new Error("isSameOrBefore: Invalid unit!");
    }
  }, {
    key: "isAfter",
    value: function isAfter(_t9) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(_t9.getFullYear(), _t9.getMonth(), _t9.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(_t9.getFullYear(), _t9.getMonth(), 1).getTime();

        case "year":
        case "years":
          return this.getFullYear() > _t9.getFullYear();
      }

      throw new Error("isAfter: Invalid unit!");
    }
  }, {
    key: "isSameOrAfter",
    value: function isSameOrAfter(_t10) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(_t10.getFullYear(), _t10.getMonth(), _t10.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(_t10.getFullYear(), _t10.getMonth(), 1).getTime();
      }

      throw new Error("isSameOrAfter: Invalid unit!");
    }
  }, {
    key: "isSame",
    value: function isSame(_t11) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(_t11.getFullYear(), _t11.getMonth(), _t11.getDate()).getTime();

        case "month":
        case "months":
          return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(_t11.getFullYear(), _t11.getMonth(), 1).getTime();
      }

      throw new Error("isSame: Invalid unit!");
    }
  }, {
    key: "add",
    value: function add(_t12) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          this.setDate(this.getDate() + _t12);
          break;

        case "month":
        case "months":
          this.setMonth(this.getMonth() + _t12);
      }

      return this;
    }
  }, {
    key: "subtract",
    value: function subtract(_t13) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        case "day":
        case "days":
          this.setDate(this.getDate() - _t13);
          break;

        case "month":
        case "months":
          this.setMonth(this.getMonth() - _t13);
      }

      return this;
    }
  }, {
    key: "diff",
    value: function diff(_t14) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "days";

      switch (e) {
        default:
        case "day":
        case "days":
          return Math.round((this.midnight_ts() - this.midnight_ts(_t14)) / 864e5);

        case "month":
        case "months":
          var _e = 12 * (_t14.getFullYear() - this.getFullYear());

          return _e -= _t14.getMonth(), _e += this.getMonth(), _e;
      }
    }
  }, {
    key: "format",
    value: function format(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
      var n = "";
      var s = [];
      var o = null;

      for (; null != (o = t.regex.exec(e));) {
        "\\" !== o[1] && s.push(o);
      }

      if (s.length) {
        s[0].index > 0 && (n += e.substring(0, s[0].index));

        for (var _i2 = 0, _Object$entries = Object.entries(s); _i2 < _Object$entries.length; _i2++) {
          var _ref3 = _Object$entries[_i2];

          var _ref2 = _slicedToArray(_ref3, 2);

          var _t17 = _ref2[0];
          var _o = _ref2[1];

          var _a = Number(_t17);

          n += this.formatTokens(_o[0], i), s[_a + 1] && (n += e.substring(_o.index + _o[0].length, s[_a + 1].index)), _a === s.length - 1 && (n += e.substring(_o.index + _o[0].length));
        }
      }

      return n.replace(/\\/g, "");
    }
  }, {
    key: "midnight_ts",
    value: function midnight_ts(_t16) {
      return _t16 ? new Date(_t16.getFullYear(), _t16.getMonth(), _t16.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
    }
  }, {
    key: "formatTokens",
    value: function formatTokens(e, i) {
      switch (e) {
        case "YY":
          return String(this.getFullYear()).slice(-2);

        case "YYYY":
          return String(this.getFullYear());

        case "M":
          return String(this.getMonth() + 1);

        case "MM":
          return "0".concat(this.getMonth() + 1).slice(-2);

        case "MMM":
          return t.shortMonths(i)[this.getMonth()];

        case "MMMM":
          return t.longMonths(i)[this.getMonth()];

        case "D":
          return String(this.getDate());

        case "DD":
          return "0".concat(this.getDate()).slice(-2);

        case "H":
          return String(this.getHours());

        case "HH":
          return "0".concat(this.getHours()).slice(-2);

        case "h":
          return String(this.getHours() % 12 || 12);

        case "hh":
          return "0".concat(this.getHours() % 12 || 12).slice(-2);

        case "m":
          return String(this.getMinutes());

        case "mm":
          return "0".concat(this.getMinutes()).slice(-2);

        case "s":
          return String(this.getSeconds());

        case "ss":
          return "0".concat(this.getSeconds()).slice(-2);

        case "a":
          return this.getHours() < 12 || 24 === this.getHours() ? "am" : "pm";

        case "A":
          return this.getHours() < 12 || 24 === this.getHours() ? "AM" : "PM";

        default:
          return "";
      }
    }
  }], [{
    key: "parseDateTime",
    value: function parseDateTime(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "YYYY-MM-DD";
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en-US";
      if (!e) return new Date(new Date().setHours(0, 0, 0, 0));
      if (e instanceof t) return e.toJSDate();
      if (e instanceof Date) return e;
      if (/^-?\d{10,}$/.test(String(e))) return new Date(Number(e));

      if ("string" == typeof e) {
        var _s2 = [];
        var _o2 = null;

        for (; null != (_o2 = t.regex.exec(i));) {
          "\\" !== _o2[1] && _s2.push(_o2);
        }

        if (_s2.length) {
          var _i3 = {
            year: null,
            month: null,
            shortMonth: null,
            longMonth: null,
            day: null,
            hour: 0,
            minute: 0,
            second: 0,
            ampm: null,
            value: ""
          };
          _s2[0].index > 0 && (_i3.value += ".*?");

          for (var _i4 = 0, _Object$entries2 = Object.entries(_s2); _i4 < _Object$entries2.length; _i4++) {
            var _ref6 = _Object$entries2[_i4];

            var _ref5 = _slicedToArray(_ref6, 2);

            var _e2 = _ref5[0];
            var _o4 = _ref5[1];

            var _s3 = Number(_e2),
                _t$formatPatterns = t.formatPatterns(_o4[0], n),
                _a2 = _t$formatPatterns.group,
                _r = _t$formatPatterns.pattern;

            _i3[_a2] = _s3 + 1, _i3.value += _r, _i3.value += ".*?";
          }

          var _o3 = new RegExp("^".concat(_i3.value, "$"));

          if (_o3.test(e)) {
            var _s4 = _o3.exec(e),
                _a3 = Number(_s4[_i3.year]);

            var _r2 = null;
            _i3.month ? _r2 = Number(_s4[_i3.month]) - 1 : _i3.shortMonth ? _r2 = t.shortMonths(n).indexOf(_s4[_i3.shortMonth]) : _i3.longMonth && (_r2 = t.longMonths(n).indexOf(_s4[_i3.longMonth]));

            var _c = Number(_s4[_i3.day]) || 1,
                _l = Number(_s4[_i3.hour]);

            var _h = Number.isNaN(_l) ? 0 : _l;

            var _d2 = Number(_s4[_i3.minute]),
                p = Number.isNaN(_d2) ? 0 : _d2,
                u = Number(_s4[_i3.second]),
                g = Number.isNaN(u) ? 0 : u,
                m = _s4[_i3.ampm];

            return m && "PM" === m && (_h += 12, 24 === _h && (_h = 0)), new Date(_a3, _r2, _c, _h, p, g, 0);
          }
        }
      }

      return new Date(new Date().setHours(0, 0, 0, 0));
    }
  }, {
    key: "shortMonths",
    value: function shortMonths(e) {
      return t.MONTH_JS.map(function (_t) {
        return new Date(2019, _t).toLocaleString(e, {
          month: "short"
        });
      });
    }
  }, {
    key: "longMonths",
    value: function longMonths(e) {
      return t.MONTH_JS.map(function (_t2) {
        return new Date(2019, _t2).toLocaleString(e, {
          month: "long"
        });
      });
    }
  }, {
    key: "formatPatterns",
    value: function formatPatterns(e, i) {
      switch (e) {
        case "YY":
        case "YYYY":
          return {
            group: "year",
            pattern: "(\\d{".concat(e.length, "})")
          };

        case "M":
          return {
            group: "month",
            pattern: "(\\d{1,2})"
          };

        case "MM":
          return {
            group: "month",
            pattern: "(\\d{2})"
          };

        case "MMM":
          return {
            group: "shortMonth",
            pattern: "(".concat(t.shortMonths(i).join("|"), ")")
          };

        case "MMMM":
          return {
            group: "longMonth",
            pattern: "(".concat(t.longMonths(i).join("|"), ")")
          };

        case "D":
          return {
            group: "day",
            pattern: "(\\d{1,2})"
          };

        case "DD":
          return {
            group: "day",
            pattern: "(\\d{2})"
          };

        case "h":
        case "H":
          return {
            group: "hour",
            pattern: "(\\d{1,2})"
          };

        case "hh":
        case "HH":
          return {
            group: "hour",
            pattern: "(\\d{2})"
          };

        case "m":
          return {
            group: "minute",
            pattern: "(\\d{1,2})"
          };

        case "mm":
          return {
            group: "minute",
            pattern: "(\\d{2})"
          };

        case "s":
          return {
            group: "second",
            pattern: "(\\d{1,2})"
          };

        case "ss":
          return {
            group: "second",
            pattern: "(\\d{2})"
          };

        case "a":
        case "A":
          return {
            group: "ampm",
            pattern: "(AM|PM|am|pm)"
          };
      }
    }
  }]);

  return t;
}( /*#__PURE__*/_wrapNativeSuper(Date));

t.regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g;
t.MONTH_JS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

var e = /*#__PURE__*/function () {
  function e(t) {
    _classCallCheck(this, e);

    this.picker = void 0;
    this.picker = t;
  }

  _createClass(e, [{
    key: "render",
    value: function render(_e3, i) {
      _e3 || (_e3 = new t()), _e3.setDate(1), _e3.setHours(0, 0, 0, 0), "function" == typeof this["get".concat(i, "View")] && this["get".concat(i, "View")](_e3);
    }
  }, {
    key: "getContainerView",
    value: function getContainerView(t) {
      this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", {
        date: t.clone(),
        view: "Header"
      }), this.picker.trigger("render", {
        date: t.clone(),
        view: "Main"
      }), this.picker.options.autoApply || this.picker.trigger("render", {
        date: t.clone(),
        view: "Footer"
      });
    }
  }, {
    key: "getHeaderView",
    value: function getHeaderView(t) {
      var _e4 = document.createElement("header");

      this.picker.options.header instanceof HTMLElement && _e4.appendChild(this.picker.options.header), "string" == typeof this.picker.options.header && (_e4.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(_e4), this.picker.trigger("view", {
        target: _e4,
        date: t.clone(),
        view: "Header"
      });
    }
  }, {
    key: "getMainView",
    value: function getMainView(t) {
      var _e5 = document.createElement("main");

      this.picker.ui.container.appendChild(_e5);
      var i = document.createElement("div");
      i.className = "calendars grid-".concat(this.picker.options.grid);

      for (var _e14 = 0; _e14 < this.picker.options.calendars; _e14++) {
        var _n2 = document.createElement("div");

        _n2.className = "calendar", i.appendChild(_n2);

        var _s5 = this.getCalendarHeaderView(t.clone());

        _n2.appendChild(_s5), this.picker.trigger("view", {
          date: t.clone(),
          view: "CalendarHeader",
          index: _e14,
          target: _s5
        });

        var _o5 = this.getCalendarDayNamesView();

        _n2.appendChild(_o5), this.picker.trigger("view", {
          date: t.clone(),
          view: "CalendarDayNames",
          index: _e14,
          target: _o5
        });

        var _a4 = this.getCalendarDaysView(t.clone());

        _n2.appendChild(_a4), this.picker.trigger("view", {
          date: t.clone(),
          view: "CalendarDays",
          index: _e14,
          target: _a4
        });

        var _r3 = this.getCalendarFooterView(this.picker.options.lang, t.clone());

        _n2.appendChild(_r3), this.picker.trigger("view", {
          date: t.clone(),
          view: "CalendarFooter",
          index: _e14,
          target: _r3
        }), this.picker.trigger("view", {
          date: t.clone(),
          view: "CalendarItem",
          index: _e14,
          target: _n2
        }), t.add(1, "month");
      }

      _e5.appendChild(i), this.picker.trigger("view", {
        date: t.clone(),
        view: "Calendars",
        target: i
      }), this.picker.trigger("view", {
        date: t.clone(),
        view: "Main",
        target: _e5
      });
    }
  }, {
    key: "getFooterView",
    value: function getFooterView(t) {
      var _e7 = document.createElement("footer"),
          i = document.createElement("div");

      i.className = "footer-buttons";
      var n = document.createElement("button");
      n.className = "cancel-button unit", n.innerHTML = this.picker.options.locale.cancel, i.appendChild(n);
      var s = document.createElement("button");
      s.className = "apply-button unit", s.innerHTML = this.picker.options.locale.apply, s.disabled = !0, i.appendChild(s), _e7.appendChild(i), this.picker.ui.container.appendChild(_e7), this.picker.trigger("view", {
        date: t,
        target: _e7,
        view: "Footer"
      });
    }
  }, {
    key: "getCalendarHeaderView",
    value: function getCalendarHeaderView(t) {
      var _e8 = document.createElement("div");

      _e8.className = "header";
      var i = document.createElement("div");
      i.className = "month-name", i.innerHTML = "<span>".concat(t.toLocaleString(this.picker.options.lang, {
        month: "long"
      }), "</span> ").concat(t.format("YYYY")), _e8.appendChild(i);
      var n = document.createElement("button");
      n.className = "previous-button unit", n.innerHTML = this.picker.options.locale.previousMonth, _e8.appendChild(n);
      var s = document.createElement("button");
      return s.className = "next-button unit", s.innerHTML = this.picker.options.locale.nextMonth, _e8.appendChild(s), _e8;
    }
  }, {
    key: "getCalendarDayNamesView",
    value: function getCalendarDayNamesView() {
      var t = document.createElement("div");
      t.className = "daynames-row";

      for (var _e15 = 1; _e15 <= 7; _e15++) {
        var _i5 = 3 + this.picker.options.firstDay + _e15,
            _n3 = document.createElement("div");

        _n3.className = "dayname", _n3.innerHTML = new Date(1970, 0, _i5, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
          weekday: "short"
        }), _n3.title = new Date(1970, 0, _i5, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
          weekday: "long"
        }), t.appendChild(_n3), this.picker.trigger("view", {
          dayIdx: _i5,
          view: "CalendarDayName",
          target: _n3
        });
      }

      return t;
    }
  }, {
    key: "getCalendarDaysView",
    value: function getCalendarDaysView(t) {
      var _e10 = document.createElement("div");

      _e10.className = "days-grid";
      var i = this.calcOffsetDays(t, this.picker.options.firstDay),
          n = 32 - new Date(t.getFullYear(), t.getMonth(), 32).getDate();

      for (var _t18 = 0; _t18 < i; _t18++) {
        var _t19 = document.createElement("div");

        _t19.className = "offset", _e10.appendChild(_t19);
      }

      for (var _i6 = 1; _i6 <= n; _i6++) {
        t.setDate(_i6);

        var _n4 = this.getCalendarDayView(t);

        _e10.appendChild(_n4), this.picker.trigger("view", {
          date: t,
          view: "CalendarDay",
          target: _n4
        });
      }

      return _e10;
    }
  }, {
    key: "getCalendarDayView",
    value: function getCalendarDayView(_e11) {
      var i = this.picker.options.date ? new t(this.picker.options.date) : null,
          n = new t(),
          s = document.createElement("div");
      return s.className = "day unit", s.innerHTML = _e11.format("D"), s.dataset.time = String(_e11.getTime()), _e11.isSame(n, "day") && s.classList.add("today"), [0, 6].includes(_e11.getDay()) && s.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(_e11, "day") && s.classList.add("selected") : i && _e11.isSame(i, "day") && s.classList.add("selected"), this.picker.trigger("view", {
        date: _e11,
        view: "CalendarDay",
        target: s
      }), s;
    }
  }, {
    key: "getCalendarFooterView",
    value: function getCalendarFooterView(t, _e12) {
      var i = document.createElement("div");
      return i.className = "footer", i;
    }
  }, {
    key: "calcOffsetDays",
    value: function calcOffsetDays(t, _e13) {
      var i = t.getDay() - _e13;

      return i < 0 && (i += 7), i;
    }
  }]);

  return e;
}();

var i = /*#__PURE__*/function () {
  function i(t) {
    _classCallCheck(this, i);

    this.picker = void 0;
    this.instances = {};
    this.picker = t;
  }

  _createClass(i, [{
    key: "initialize",
    value: function initialize() {
      var _this3 = this;

      var t = [];
      this.picker.options.plugins.forEach(function (e) {
        "function" == typeof e ? t.push(new e()) : "string" == typeof e && "undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, e) ? t.push(new easepick[e]()) : console.warn("easepick: ".concat(e, " not found."));
      }), t.sort(function (t, e) {
        return t.priority > e.priority ? -1 : t.priority < e.priority || t.dependencies.length > e.dependencies.length ? 1 : t.dependencies.length < e.dependencies.length ? -1 : 0;
      }), t.forEach(function (t) {
        t.attach(_this3.picker), _this3.instances[t.getName()] = t;
      });
    }
  }, {
    key: "getInstance",
    value: function getInstance(t) {
      return this.instances[t];
    }
  }, {
    key: "addInstance",
    value: function addInstance(t) {
      if (Object.prototype.hasOwnProperty.call(this.instances, t)) console.warn("easepick: ".concat(t, " already added."));else {
        if ("undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, t)) {
          var _e16 = new easepick[t]();

          return _e16.attach(this.picker), this.instances[_e16.getName()] = _e16, _e16;
        }

        if ("undefined" !== this.getPluginFn(t)) {
          var _e17 = new (this.getPluginFn(t))();

          return _e17.attach(this.picker), this.instances[_e17.getName()] = _e17, _e17;
        }

        console.warn("easepick: ".concat(t, " not found."));
      }
      return null;
    }
  }, {
    key: "removeInstance",
    value: function removeInstance(t) {
      return t in this.instances && this.instances[t].detach(), delete this.instances[t];
    }
  }, {
    key: "reloadInstance",
    value: function reloadInstance(t) {
      return this.removeInstance(t), this.addInstance(t);
    }
  }, {
    key: "getPluginFn",
    value: function getPluginFn(t) {
      return _toConsumableArray(this.picker.options.plugins).filter(function (e) {
        return "function" == typeof e && new e().getName() === t;
      }).shift();
    }
  }]);

  return i;
}();

var n = /*#__PURE__*/function () {
  function n(t) {
    _classCallCheck(this, n);

    this.Calendar = new e(this);
    this.PluginManager = new i(this);
    this.calendars = [];
    this.datePicked = [];
    this.cssLoaded = 0;
    this.binds = {
      hidePicker: this.hidePicker.bind(this),
      show: this.show.bind(this)
    };
    this.options = {
      doc: document,
      css: [],
      element: null,
      firstDay: 1,
      grid: 1,
      calendars: 1,
      lang: "en-US",
      date: null,
      format: "YYYY-MM-DD",
      readonly: !0,
      autoApply: !0,
      header: !1,
      inline: !1,
      scrollToDate: !0,
      locale: {
        nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
        previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
        cancel: "Cancel",
        apply: "Apply"
      },
      documentClick: this.binds.hidePicker,
      plugins: []
    };
    this.ui = {
      container: null,
      shadowRoot: null,
      wrapper: null
    };
    this.version = "1.2.0";

    var _e18 = _objectSpread(_objectSpread({}, this.options.locale), t.locale);

    this.options = _objectSpread(_objectSpread({}, this.options), t), this.options.locale = _e18, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({
      mode: "open"
    }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), "function" == typeof this.options.setup && this.options.setup(this), this.on("click", this.onClick.bind(this));

    var _i7 = this.options.scrollToDate ? this.getDate() : null;

    this.renderAll(_i7);
  }

  _createClass(n, [{
    key: "on",
    value: function on(t, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.ui.container.addEventListener(t, e, i);
    }
  }, {
    key: "off",
    value: function off(t, e) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.ui.container.removeEventListener(t, e, i);
    }
  }, {
    key: "trigger",
    value: function trigger(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.ui.container.dispatchEvent(new CustomEvent(t, {
        detail: e
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this4 = this;

      this.options.element.removeEventListener("click", this.binds.show), "function" == typeof this.options.documentClick && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach(function (t) {
        _this4.PluginManager.removeInstance(t);
      }), this.ui.wrapper.remove();
    }
  }, {
    key: "onRender",
    value: function onRender(t) {
      var _t$detail = t.detail,
          e = _t$detail.view,
          i = _t$detail.date;
      this.Calendar.render(i, e);
    }
  }, {
    key: "onView",
    value: function onView(t) {
      var _t$detail2 = t.detail,
          e = _t$detail2.view,
          i = _t$detail2.target;
      "Footer" === e && this.datePicked.length && (i.querySelector(".apply-button").disabled = !1);
    }
  }, {
    key: "onClickHeaderButton",
    value: function onClickHeaderButton(t) {
      this.isCalendarHeaderButton(t) && (t.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
    }
  }, {
    key: "onClickCalendarDay",
    value: function onClickCalendarDay(e) {
      if (this.isCalendarDay(e)) {
        var _i8 = new t(e.dataset.time);

        this.options.autoApply ? (this.setDate(_i8), this.trigger("select", {
          date: this.getDate()
        }), this.hide()) : (this.datePicked[0] = _i8, this.trigger("preselect", {
          date: this.getDate()
        }), this.renderAll());
      }
    }
  }, {
    key: "onClickApplyButton",
    value: function onClickApplyButton(t) {
      if (this.isApplyButton(t)) {
        if (this.datePicked[0] instanceof Date) {
          var _t20 = this.datePicked[0].clone();

          this.setDate(_t20);
        }

        this.hide(), this.trigger("select", {
          date: this.getDate()
        });
      }
    }
  }, {
    key: "onClickCancelButton",
    value: function onClickCancelButton(t) {
      this.isCancelButton(t) && this.hide();
    }
  }, {
    key: "onClick",
    value: function onClick(t) {
      var e = t.target;

      if (e instanceof HTMLElement) {
        var _t21 = e.closest(".unit");

        if (!(_t21 instanceof HTMLElement)) return;
        this.onClickHeaderButton(_t21), this.onClickCalendarDay(_t21), this.onClickApplyButton(_t21), this.onClickCancelButton(_t21);
      }
    }
  }, {
    key: "isShown",
    value: function isShown() {
      return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
    }
  }, {
    key: "show",
    value: function show(t) {
      if (this.isShown()) return;

      var e = t && "target" in t ? t.target : this.options.element,
          _this$adjustPosition = this.adjustPosition(e),
          i = _this$adjustPosition.top,
          _n5 = _this$adjustPosition.left;

      this.ui.container.style.top = "".concat(i, "px"), this.ui.container.style.left = "".concat(_n5, "px"), this.ui.container.classList.add("show"), this.trigger("show", {
        target: e
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
    }
  }, {
    key: "setDate",
    value: function setDate(e) {
      var i = new t(e, this.options.format);
      this.options.date = i.clone(), this.updateValues(), this.calendars.length && this.renderAll();
    }
  }, {
    key: "getDate",
    value: function getDate() {
      return this.options.date instanceof t ? this.options.date.clone() : null;
    }
  }, {
    key: "parseValues",
    value: function parseValues() {
      this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
    }
  }, {
    key: "updateValues",
    value: function updateValues() {
      var t = this.getDate(),
          e = t instanceof Date ? t.format(this.options.format, this.options.lang) : "",
          i = this.options.element;
      i instanceof HTMLInputElement ? i.value = e : i instanceof HTMLElement && (i.innerText = e);
    }
  }, {
    key: "hidePicker",
    value: function hidePicker(t) {
      var e = t.target,
          i = null;
      e.shadowRoot && (e = t.composedPath()[0], i = e.getRootNode().host), this.isShown() && i !== this.ui.wrapper && e !== this.options.element && this.hide();
    }
  }, {
    key: "renderAll",
    value: function renderAll(t) {
      this.trigger("render", {
        view: "Container",
        date: (t || this.calendars[0]).clone()
      });
    }
  }, {
    key: "isCalendarHeaderButton",
    value: function isCalendarHeaderButton(t) {
      return ["previous-button", "next-button"].some(function (e) {
        return t.classList.contains(e);
      });
    }
  }, {
    key: "isCalendarDay",
    value: function isCalendarDay(t) {
      return t.classList.contains("day");
    }
  }, {
    key: "isApplyButton",
    value: function isApplyButton(t) {
      return t.classList.contains("apply-button");
    }
  }, {
    key: "isCancelButton",
    value: function isCancelButton(t) {
      return t.classList.contains("cancel-button");
    }
  }, {
    key: "gotoDate",
    value: function gotoDate(e) {
      var i = new t(e, this.options.format);
      i.setDate(1), this.calendars[0] = i.clone(), this.renderAll();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
    }
  }, {
    key: "handleOptions",
    value: function handleOptions() {
      this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new t(this.options.date, this.options.format) : this.calendars[0] = new t();
    }
  }, {
    key: "handleCSS",
    value: function handleCSS() {
      var _this5 = this;

      if (Array.isArray(this.options.css)) this.options.css.forEach(function (t) {
        var e = document.createElement("link");
        e.href = t, e.rel = "stylesheet";

        var i = function i() {
          _this5.cssLoaded++, _this5.cssLoaded === _this5.options.css.length && (_this5.ui.wrapper.style.display = "");
        };

        e.addEventListener("load", i), e.addEventListener("error", i), _this5.ui.shadowRoot.append(e);
      });else if ("string" == typeof this.options.css) {
        var _t22 = document.createElement("style"),
            _e19 = document.createTextNode(this.options.css);

        _t22.appendChild(_e19), this.ui.shadowRoot.append(_t22), this.ui.wrapper.style.display = "";
      } else "function" == typeof this.options.css && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
    }
  }, {
    key: "adjustPosition",
    value: function adjustPosition(t) {
      var e = t.getBoundingClientRect(),
          i = this.ui.wrapper.getBoundingClientRect();
      this.ui.container.classList.add("calc");

      var _n6 = this.ui.container.getBoundingClientRect();

      this.ui.container.classList.remove("calc");
      var s = e.bottom - i.bottom,
          o = e.left - i.left;
      return "undefined" != typeof window && (window.innerHeight < s + _n6.height && s - _n6.height >= 0 && (s = e.top - i.top - _n6.height), window.innerWidth < o + _n6.width && e.right - _n6.width >= 0 && (o = e.right - i.right - _n6.width)), {
        left: o,
        top: s
      };
    }
  }]);

  return n;
}();

var s = Object.freeze({
  __proto__: null,
  Core: n,
  create: n
});

var o = /*#__PURE__*/function () {
  function o() {
    _classCallCheck(this, o);

    this.picker = void 0;
    this.options = void 0;
    this.priority = 0;
    this.dependencies = [];
  }

  _createClass(o, [{
    key: "attach",
    value: function attach(t) {
      var _this6 = this;

      var e = this.getName(),
          i = _objectSpread({}, this.options);

      this.options = _objectSpread(_objectSpread({}, this.options), t.options[e] || {});

      var _loop = function _loop() {
        var n = _Object$keys[_i9];

        if (null !== i[n] && "object" == _typeof(i[n]) && Object.keys(i[n]).length && e in t.options && n in t.options[e]) {
          var _s6 = _objectSpread({}, t.options[e][n]);

          null !== _s6 && "object" == _typeof(_s6) && Object.keys(_s6).length && Object.keys(_s6).every(function (t) {
            return Object.keys(i[n]).includes(t);
          }) && (_this6.options[n] = _objectSpread(_objectSpread({}, i[n]), _s6));
        }
      };

      for (var _i9 = 0, _Object$keys = Object.keys(i); _i9 < _Object$keys.length; _i9++) {
        _loop();
      }

      if (this.picker = t, this.dependenciesNotFound()) {
        var _t23 = this.dependencies.filter(function (t) {
          return !_this6.pluginsAsStringArray().includes(t);
        });

        return void console.warn("".concat(this.getName(), ": required dependencies (").concat(_t23.join(", "), ")."));
      }

      var n = this.camelCaseToKebab(this.getName());
      this.picker.ui.container.classList.add(n), this.onAttach();
    }
  }, {
    key: "detach",
    value: function detach() {
      var t = this.camelCaseToKebab(this.getName());
      this.picker.ui.container.classList.remove(t), "function" == typeof this.onDetach && this.onDetach();
    }
  }, {
    key: "dependenciesNotFound",
    value: function dependenciesNotFound() {
      var _this7 = this;

      return this.dependencies.length && !this.dependencies.every(function (t) {
        return _this7.pluginsAsStringArray().includes(t);
      });
    }
  }, {
    key: "pluginsAsStringArray",
    value: function pluginsAsStringArray() {
      return this.picker.options.plugins.map(function (t) {
        return "function" == typeof t ? new t().getName() : t;
      });
    }
  }, {
    key: "camelCaseToKebab",
    value: function camelCaseToKebab(t) {
      return t.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
    }
  }]);

  return o;
}();

var a = /*#__PURE__*/function (_o6) {
  _inherits(a, _o6);

  var _super2 = _createSuper(a);

  function a() {
    var _this8;

    _classCallCheck(this, a);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this8 = _super2.call.apply(_super2, [this].concat(args));
    _this8.priority = 1;
    _this8.binds = {
      onView: _this8.onView.bind(_assertThisInitialized(_this8))
    };
    _this8.options = {
      minDate: null,
      maxDate: null,
      minDays: null,
      maxDays: null,
      selectForward: null,
      selectBackward: null,
      presets: !0,
      inseparable: !1,
      filter: null
    };
    return _this8;
  }

  _createClass(a, [{
    key: "getName",
    value: function getName() {
      return "LockPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      if (this.options.minDate && (this.options.minDate = new t(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new t(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof t && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
        var _t24 = this.picker.calendars[0].clone().subtract(1, "month");

        this.picker.gotoDate(_t24);
      }

      if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
        var _t25 = ["minDays", "maxDays", "selectForward", "selectBackward"];
        console.warn("".concat(this.getName(), ": options ").concat(_t25.join(", "), " required RangePlugin."));
      }

      this.picker.on("view", this.binds.onView);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.picker.off("view", this.binds.onView);
    }
  }, {
    key: "onView",
    value: function onView(e) {
      var _e$detail = e.detail,
          i = _e$detail.view,
          n = _e$detail.target,
          s = _e$detail.date;

      if ("CalendarHeader" === i && (this.options.minDate instanceof t && s.isSameOrBefore(this.options.minDate, "month") && n.classList.add("no-previous-month"), this.options.maxDate instanceof t && s.isSameOrAfter(this.options.maxDate, "month") && n.classList.add("no-next-month")), "CalendarDay" === i) {
        var _t26 = this.picker.datePicked.length ? this.picker.datePicked[0] : null;

        if (this.testFilter(s)) return void n.classList.add("locked");

        if (this.options.inseparable) {
          if (this.options.minDays) {
            var _t27 = s.clone().subtract(this.options.minDays - 1, "day"),
                _e20 = s.clone().add(this.options.minDays - 1, "day");

            var _i10 = !1,
                _o7 = !1;

            for (; _t27.isBefore(s, "day");) {
              if (this.testFilter(_t27)) {
                _i10 = !0;
                break;
              }

              _t27.add(1, "day");
            }

            for (; _e20.isAfter(s, "day");) {
              if (this.testFilter(_e20)) {
                _o7 = !0;
                break;
              }

              _e20.subtract(1, "day");
            }

            _i10 && _o7 && n.classList.add("not-available");
          }

          this.rangeIsNotAvailable(s, _t26) && n.classList.add("not-available");
        }

        this.dateIsNotAvailable(s, _t26) && n.classList.add("not-available");
      }

      if (this.options.presets && "PresetPluginButton" === i) {
        var _e21 = new t(Number(n.dataset.start)),
            _i11 = new t(Number(n.dataset.end)),
            _s7 = _i11.diff(_e21, "day"),
            _o8 = this.options.minDays && _s7 < this.options.minDays,
            _a6 = this.options.maxDays && _s7 > this.options.maxDays;

        (_o8 || _a6 || this.lockMinDate(_e21) || this.lockMaxDate(_e21) || this.lockMinDate(_i11) || this.lockMaxDate(_i11) || this.rangeIsNotAvailable(_e21, _i11)) && n.setAttribute("disabled", "disabled");
      }
    }
  }, {
    key: "dateIsNotAvailable",
    value: function dateIsNotAvailable(t, e) {
      return this.lockMinDate(t) || this.lockMaxDate(t) || this.lockMinDays(t, e) || this.lockMaxDays(t, e) || this.lockSelectForward(t) || this.lockSelectBackward(t);
    }
  }, {
    key: "rangeIsNotAvailable",
    value: function rangeIsNotAvailable(t, e) {
      if (!t || !e) return !1;
      var i = (t.isSameOrBefore(e, "day") ? t : e).clone(),
          n = (e.isSameOrAfter(t, "day") ? e : t).clone();

      for (; i.isSameOrBefore(n, "day");) {
        if (this.testFilter(i)) return !0;
        i.add(1, "day");
      }

      return !1;
    }
  }, {
    key: "lockMinDate",
    value: function lockMinDate(e) {
      return this.options.minDate instanceof t && e.isBefore(this.options.minDate, "day");
    }
  }, {
    key: "lockMaxDate",
    value: function lockMaxDate(e) {
      return this.options.maxDate instanceof t && e.isAfter(this.options.maxDate, "day");
    }
  }, {
    key: "lockMinDays",
    value: function lockMinDays(t, e) {
      if (this.options.minDays && e) {
        var _i12 = e.clone().subtract(this.options.minDays - 1, "day"),
            _n7 = e.clone().add(this.options.minDays - 1, "day");

        return t.isBetween(_i12, _n7);
      }

      return !1;
    }
  }, {
    key: "lockMaxDays",
    value: function lockMaxDays(t, e) {
      if (this.options.maxDays && e) {
        var _i13 = e.clone().subtract(this.options.maxDays, "day"),
            _n8 = e.clone().add(this.options.maxDays, "day");

        return !t.isBetween(_i13, _n8);
      }

      return !1;
    }
  }, {
    key: "lockSelectForward",
    value: function lockSelectForward(t) {
      if (1 === this.picker.datePicked.length && this.options.selectForward) {
        var _e22 = this.picker.datePicked[0].clone();

        return t.isBefore(_e22, "day");
      }

      return !1;
    }
  }, {
    key: "lockSelectBackward",
    value: function lockSelectBackward(t) {
      if (1 === this.picker.datePicked.length && this.options.selectBackward) {
        var _e23 = this.picker.datePicked[0].clone();

        return t.isAfter(_e23, "day");
      }

      return !1;
    }
  }, {
    key: "testFilter",
    value: function testFilter(t) {
      return "function" == typeof this.options.filter && this.options.filter(t, this.picker.datePicked);
    }
  }]);

  return a;
}(o);

var r = /*#__PURE__*/function (_o9) {
  _inherits(r, _o9);

  var _super3 = _createSuper(r);

  function r() {
    var _this9;

    _classCallCheck(this, r);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this9 = _super3.call.apply(_super3, [this].concat(args));
    _this9.dependencies = ["RangePlugin"];
    _this9.binds = {
      onView: _this9.onView.bind(_assertThisInitialized(_this9)),
      onClick: _this9.onClick.bind(_assertThisInitialized(_this9))
    };
    _this9.options = {
      customLabels: ["Today", "Yesterday", "Last 7 Days", "Last 30 Days", "This Month", "Last Month"],
      customPreset: {},
      position: "left"
    };
    return _this9;
  }

  _createClass(r, [{
    key: "getName",
    value: function getName() {
      return "PresetPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      var _this10 = this;

      if (!Object.keys(this.options.customPreset).length) {
        var _e24 = new t(),
            _i14 = function _i14() {
          var i = _e24.clone();

          i.setDate(1);
          var n = new Date(_e24.getFullYear(), _e24.getMonth() + 1, 0);
          return [new t(i), new t(n)];
        },
            _n9 = function _n9() {
          var i = _e24.clone();

          i.setMonth(i.getMonth() - 1), i.setDate(1);
          var n = new Date(_e24.getFullYear(), _e24.getMonth(), 0);
          return [new t(i), new t(n)];
        },
            _s8 = [[_e24.clone(), _e24.clone()], [_e24.clone().subtract(1, "day"), _e24.clone().subtract(1, "day")], [_e24.clone().subtract(6, "day"), _e24.clone()], [_e24.clone().subtract(29, "day"), _e24.clone()], _i14(), _n9()];

        Object.values(this.options.customLabels).forEach(function (t, e) {
          _this10.options.customPreset[t] = _s8[e];
        });
      }

      this.picker.on("view", this.binds.onView), this.picker.on("click", this.binds.onClick);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.picker.off("view", this.binds.onView), this.picker.off("click", this.binds.onClick);
    }
  }, {
    key: "onView",
    value: function onView(t) {
      var _this11 = this;

      var _t$detail3 = t.detail,
          e = _t$detail3.view,
          i = _t$detail3.target;

      if ("Main" === e) {
        var _t28 = document.createElement("div");

        _t28.className = "preset-plugin-container", Object.keys(this.options.customPreset).forEach(function (e) {
          if (Object.prototype.hasOwnProperty.call(_this11.options.customPreset, e)) {
            var _i15 = _this11.options.customPreset[e],
                _n10 = document.createElement("button");

            _n10.className = "preset-button unit", _n10.innerHTML = e, _n10.dataset.start = _i15[0].getTime(), _n10.dataset.end = _i15[1].getTime(), _t28.appendChild(_n10), _this11.picker.trigger("view", {
              view: "PresetPluginButton",
              target: _n10
            });
          }
        }), i.appendChild(_t28), i.classList.add("preset-".concat(this.options.position)), this.picker.trigger("view", {
          view: "PresetPluginContainer",
          target: _t28
        });
      }
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      var i = e.target;

      if (i instanceof HTMLElement) {
        var _e25 = i.closest(".unit");

        if (!(_e25 instanceof HTMLElement)) return;

        if (this.isPresetButton(_e25)) {
          var _i16 = new t(Number(_e25.dataset.start)),
              _n11 = new t(Number(_e25.dataset.end));

          this.picker.options.autoApply ? (this.picker.setDateRange(_i16, _n11), this.picker.trigger("select", {
            start: this.picker.getStartDate(),
            end: this.picker.getEndDate()
          }), this.picker.hide()) : (this.picker.datePicked = [_i16, _n11], this.picker.renderAll());
        }
      }
    }
  }, {
    key: "isPresetButton",
    value: function isPresetButton(t) {
      return t.classList.contains("preset-button");
    }
  }]);

  return r;
}(o);

var c = /*#__PURE__*/function (_o10) {
  _inherits(c, _o10);

  var _super4 = _createSuper(c);

  function c() {
    var _this12;

    _classCallCheck(this, c);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this12 = _super4.call.apply(_super4, [this].concat(args));
    _this12.tooltipElement = void 0;
    _this12.triggerElement = void 0;
    _this12.binds = {
      setStartDate: _this12.setStartDate.bind(_assertThisInitialized(_this12)),
      setEndDate: _this12.setEndDate.bind(_assertThisInitialized(_this12)),
      setDateRange: _this12.setDateRange.bind(_assertThisInitialized(_this12)),
      getStartDate: _this12.getStartDate.bind(_assertThisInitialized(_this12)),
      getEndDate: _this12.getEndDate.bind(_assertThisInitialized(_this12)),
      onView: _this12.onView.bind(_assertThisInitialized(_this12)),
      onShow: _this12.onShow.bind(_assertThisInitialized(_this12)),
      onMouseEnter: _this12.onMouseEnter.bind(_assertThisInitialized(_this12)),
      onMouseLeave: _this12.onMouseLeave.bind(_assertThisInitialized(_this12)),
      onClickCalendarDay: _this12.onClickCalendarDay.bind(_assertThisInitialized(_this12)),
      onClickApplyButton: _this12.onClickApplyButton.bind(_assertThisInitialized(_this12)),
      parseValues: _this12.parseValues.bind(_assertThisInitialized(_this12)),
      updateValues: _this12.updateValues.bind(_assertThisInitialized(_this12)),
      clear: _this12.clear.bind(_assertThisInitialized(_this12))
    };
    _this12.options = {
      elementEnd: null,
      startDate: null,
      endDate: null,
      repick: !1,
      strict: !0,
      delimiter: " - ",
      tooltip: !0,
      tooltipNumber: function tooltipNumber(t) {
        return t;
      },
      locale: {
        zero: "",
        one: "day",
        two: "",
        few: "",
        many: "",
        other: "days"
      },
      documentClick: _this12.hidePicker.bind(_assertThisInitialized(_this12))
    };
    return _this12;
  }

  _createClass(c, [{
    key: "getName",
    value: function getName() {
      return "RangePlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, {
        setStartDate: {
          configurable: !0,
          value: this.binds.setStartDate
        },
        setEndDate: {
          configurable: !0,
          value: this.binds.setEndDate
        },
        setDateRange: {
          configurable: !0,
          value: this.binds.setDateRange
        },
        getStartDate: {
          configurable: !0,
          value: this.binds.getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds.getEndDate
        },
        parseValues: {
          configurable: !0,
          value: this.binds.parseValues
        },
        updateValues: {
          configurable: !0,
          value: this.binds.updateValues
        },
        clear: {
          configurable: !0,
          value: this.binds.clear
        },
        onClickCalendarDay: {
          configurable: !0,
          value: this.binds.onClickCalendarDay
        },
        onClickApplyButton: {
          configurable: !0,
          value: this.binds.onClickApplyButton
        }
      }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), "function" == typeof this.picker.options.documentClick && (document.removeEventListener("click", this.picker.options.documentClick, !0), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      Object.defineProperties(this.picker, {
        setStartDate: {
          configurable: !0,
          value: this.binds._setStartDate
        },
        setEndDate: {
          configurable: !0,
          value: this.binds._setEndDate
        },
        setDateRange: {
          configurable: !0,
          value: this.binds._setDateRange
        },
        getStartDate: {
          configurable: !0,
          value: this.binds._getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds._getEndDate
        },
        parseValues: {
          configurable: !0,
          value: this.binds._parseValues
        },
        updateValues: {
          configurable: !0,
          value: this.binds._updateValues
        },
        clear: {
          configurable: !0,
          value: this.binds._clear
        },
        onClickCalendarDay: {
          configurable: !0,
          value: this.binds._onClickCalendarDay
        },
        onClickApplyButton: {
          configurable: !0,
          value: this.binds._onClickApplyButton
        }
      }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
    }
  }, {
    key: "parseValues",
    value: function parseValues() {
      if (this.options.startDate || this.options.endDate) this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));else if (this.options.elementEnd) this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
        var _this$picker$options$ = this.picker.options.element.value.split(this.options.delimiter),
            _this$picker$options$2 = _slicedToArray(_this$picker$options$, 2),
            _t29 = _this$picker$options$2[0],
            _e26 = _this$picker$options$2[1];

        this.options.strict ? _t29 && _e26 && this.setDateRange(_t29, _e26) : (_t29 && this.setStartDate(_t29), _e26 && this.setEndDate(_e26));
      }
    }
  }, {
    key: "updateValues",
    value: function updateValues() {
      var t = this.picker.options.element,
          e = this.options.elementEnd,
          i = this.picker.getStartDate(),
          n = this.picker.getEndDate(),
          s = i instanceof Date ? i.format(this.picker.options.format, this.picker.options.lang) : "",
          o = n instanceof Date ? n.format(this.picker.options.format, this.picker.options.lang) : "";
      if (e) t instanceof HTMLInputElement ? t.value = s : t instanceof HTMLElement && (t.innerText = s), e instanceof HTMLInputElement ? e.value = o : e instanceof HTMLElement && (e.innerText = o);else {
        var _e27 = "".concat(s).concat(s || o ? this.options.delimiter : "").concat(o);

        t instanceof HTMLInputElement ? t.value = _e27 : t instanceof HTMLElement && (t.innerText = _e27);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
    }
  }, {
    key: "onShow",
    value: function onShow(t) {
      var e = t.detail.target;
      this.triggerElement = e, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
    }
  }, {
    key: "onView",
    value: function onView(e) {
      var _e$detail2 = e.detail,
          i = _e$detail2.view,
          n = _e$detail2.target;

      if ("Main" === i && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", n.appendChild(this.tooltipElement)), "CalendarDay" === i) {
        var _e28 = new t(n.dataset.time),
            _i17 = this.picker.datePicked,
            _s9 = _i17.length ? this.picker.datePicked[0] : this.getStartDate(),
            _o11 = _i17.length ? this.picker.datePicked[1] : this.getEndDate();

        _s9 && _s9.isSame(_e28, "day") && n.classList.add("start"), _s9 && _o11 && (_o11.isSame(_e28, "day") && n.classList.add("end"), _e28.isBetween(_s9, _o11) && n.classList.add("in-range"));
      }

      if ("Footer" === i) {
        var _t30 = 1 === this.picker.datePicked.length && !this.options.strict || 2 === this.picker.datePicked.length;

        n.querySelector(".apply-button").disabled = !_t30;
      }
    }
  }, {
    key: "hidePicker",
    value: function hidePicker(t) {
      var e = t.target,
          i = null;
      e.shadowRoot && (e = t.composedPath()[0], i = e.getRootNode().host), this.picker.isShown() && i !== this.picker.ui.wrapper && e !== this.picker.options.element && e !== this.options.elementEnd && this.picker.hide();
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(e) {
      var i = new t(e, this.picker.options.format);
      this.options.startDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(e) {
      var i = new t(e, this.picker.options.format);
      this.options.endDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "setDateRange",
    value: function setDateRange(e, i) {
      var n = new t(e, this.picker.options.format),
          s = new t(i, this.picker.options.format);
      this.options.startDate = n ? n.clone() : null, this.options.endDate = s ? s.clone() : null, this.updateValues(), this.picker.renderAll();
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      var _this13 = this;

      var i = e.target;

      if (i instanceof HTMLElement) {
        this.isContainer(i) && this.initializeRepick();

        var _e29 = i.closest(".unit");

        if (!(_e29 instanceof HTMLElement)) return;

        if (this.picker.isCalendarDay(_e29)) {
          if (1 !== this.picker.datePicked.length) return;

          var _i18 = this.picker.datePicked[0].clone(),
              _n12 = new t(_e29.dataset.time),
              _s10 = !1;

          if (_i18.isAfter(_n12, "day")) {
            var _t31 = _i18.clone();

            _i18 = _n12.clone(), _n12 = _t31.clone(), _s10 = !0;
          }

          if (_toConsumableArray(this.picker.ui.container.querySelectorAll(".day")).forEach(function (o) {
            var a = new t(o.dataset.time),
                r = _this13.picker.Calendar.getCalendarDayView(a);

            a.isBetween(_i18, _n12) && r.classList.add("in-range"), a.isSame(_this13.picker.datePicked[0], "day") && (r.classList.add("start"), r.classList.toggle("flipped", _s10)), o === _e29 && (r.classList.add("end"), r.classList.toggle("flipped", _s10)), o.className = r.className;
          }), this.options.tooltip) {
            var _t32 = this.options.tooltipNumber(_n12.diff(_i18, "day") + 1);

            if (_t32 > 0) {
              var _i19 = new Intl.PluralRules(this.picker.options.lang).select(_t32),
                  _n13 = "".concat(_t32, " ").concat(this.options.locale[_i19]);

              this.showTooltip(_e29, _n13);
            } else this.hideTooltip();
          }
        }
      }
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(t) {
      if (this.isContainer(t.target) && this.options.repick) {
        var _t33 = this.getStartDate(),
            _e30 = this.getEndDate();

        _t33 && _e30 && (this.picker.datePicked.length = 0, this.picker.renderAll());
      }
    }
  }, {
    key: "onClickCalendarDay",
    value: function onClickCalendarDay(e) {
      if (this.picker.isCalendarDay(e)) {
        2 === this.picker.datePicked.length && (this.picker.datePicked.length = 0);

        var _i20 = new t(e.dataset.time);

        if (this.picker.datePicked[this.picker.datePicked.length] = _i20, 2 === this.picker.datePicked.length && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
          var _t34 = this.picker.datePicked[1].clone();

          this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = _t34.clone();
        }

        1 !== this.picker.datePicked.length && this.picker.options.autoApply || this.picker.trigger("preselect", {
          start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null,
          end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null
        }), 1 === this.picker.datePicked.length && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", {
          start: this.picker.getStartDate(),
          end: this.picker.getEndDate()
        })), this.picker.renderAll()), 2 === this.picker.datePicked.length && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
          start: this.picker.getStartDate(),
          end: this.picker.getEndDate()
        }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
      }
    }
  }, {
    key: "onClickApplyButton",
    value: function onClickApplyButton(t) {
      this.picker.isApplyButton(t) && (1 !== this.picker.datePicked.length || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), 2 === this.picker.datePicked.length && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
        start: this.picker.getStartDate(),
        end: this.picker.getEndDate()
      }), this.picker.hide());
    }
  }, {
    key: "showTooltip",
    value: function showTooltip(t, e) {
      this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = e;
      var i = this.picker.ui.container.getBoundingClientRect(),
          n = this.tooltipElement.getBoundingClientRect(),
          s = t.getBoundingClientRect();
      var o = s.top,
          a = s.left;
      o -= i.top, a -= i.left, o -= n.height, a -= n.width / 2, a += s.width / 2, this.tooltipElement.style.top = "".concat(o, "px"), this.tooltipElement.style.left = "".concat(a, "px");
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this.tooltipElement.style.visibility = "hidden";
    }
  }, {
    key: "checkIntlPluralLocales",
    value: function checkIntlPluralLocales() {
      if (!this.options.tooltip) return;

      var t = _toConsumableArray(new Set([new Intl.PluralRules(this.picker.options.lang).select(0), new Intl.PluralRules(this.picker.options.lang).select(1), new Intl.PluralRules(this.picker.options.lang).select(2), new Intl.PluralRules(this.picker.options.lang).select(6), new Intl.PluralRules(this.picker.options.lang).select(18)])),
          e = Object.keys(this.options.locale);

      t.every(function (t) {
        return e.includes(t);
      }) || console.warn("".concat(this.getName(), ": provide locales (").concat(t.join(", "), ") for correct tooltip text."));
    }
  }, {
    key: "initializeRepick",
    value: function initializeRepick() {
      if (!this.options.repick) return;
      var t = this.getStartDate(),
          e = this.getEndDate();
      e && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = e), t && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = t);
    }
  }, {
    key: "isContainer",
    value: function isContainer(t) {
      return t === this.picker.ui.container;
    }
  }]);

  return c;
}(o);

var l = /*#__PURE__*/function (_o12) {
  _inherits(l, _o12);

  var _super5 = _createSuper(l);

  function l() {
    var _this14;

    _classCallCheck(this, l);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this14 = _super5.call.apply(_super5, [this].concat(args));
    _this14.options = {
      native: !1,
      seconds: !1,
      stepHours: 1,
      stepMinutes: 5,
      stepSeconds: 5,
      format12: !1
    };
    _this14.rangePlugin = void 0;
    _this14.timePicked = {
      input: null,
      start: null,
      end: null
    };
    _this14.timePrePicked = {
      input: null,
      start: null,
      end: null
    };
    _this14.binds = {
      getDate: _this14.getDate.bind(_assertThisInitialized(_this14)),
      getStartDate: _this14.getStartDate.bind(_assertThisInitialized(_this14)),
      getEndDate: _this14.getEndDate.bind(_assertThisInitialized(_this14)),
      onView: _this14.onView.bind(_assertThisInitialized(_this14)),
      onInput: _this14.onInput.bind(_assertThisInitialized(_this14)),
      onChange: _this14.onChange.bind(_assertThisInitialized(_this14)),
      onClick: _this14.onClick.bind(_assertThisInitialized(_this14)),
      setTime: _this14.setTime.bind(_assertThisInitialized(_this14)),
      setStartTime: _this14.setStartTime.bind(_assertThisInitialized(_this14)),
      setEndTime: _this14.setEndTime.bind(_assertThisInitialized(_this14))
    };
    return _this14;
  }

  _createClass(l, [{
    key: "getName",
    value: function getName() {
      return "TimePlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.binds._getDate = this.picker.getDate, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, Object.defineProperties(this.picker, {
        getDate: {
          configurable: !0,
          value: this.binds.getDate
        },
        getStartDate: {
          configurable: !0,
          value: this.binds.getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds.getEndDate
        },
        setTime: {
          configurable: !0,
          value: this.binds.setTime
        },
        setStartTime: {
          configurable: !0,
          value: this.binds.setStartTime
        },
        setEndTime: {
          configurable: !0,
          value: this.binds.setEndTime
        }
      }), this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.parseValues(), this.picker.on("view", this.binds.onView), this.picker.on("input", this.binds.onInput), this.picker.on("change", this.binds.onChange), this.picker.on("click", this.binds.onClick);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      delete this.picker.setTime, delete this.picker.setStartTime, delete this.picker.setEndTime, Object.defineProperties(this.picker, {
        getDate: {
          configurable: !0,
          value: this.binds._getDate
        },
        getStartDate: {
          configurable: !0,
          value: this.binds._getStartDate
        },
        getEndDate: {
          configurable: !0,
          value: this.binds._getEndDate
        }
      }), this.picker.off("view", this.binds.onView), this.picker.off("input", this.binds.onInput), this.picker.off("change", this.binds.onChange), this.picker.off("click", this.binds.onClick);
    }
  }, {
    key: "onView",
    value: function onView(t) {
      var _t$detail4 = t.detail,
          e = _t$detail4.view,
          i = _t$detail4.target;

      if ("Main" === e) {
        this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin");

        var _t35 = document.createElement("div");

        if (_t35.className = "time-plugin-container", this.rangePlugin) {
          var _e31 = this.getStartInput();

          _t35.appendChild(_e31), this.picker.trigger("view", {
            view: "TimePluginInput",
            target: _e31
          });

          var _i21 = this.getEndInput();

          _t35.appendChild(_i21), this.picker.trigger("view", {
            view: "TimePluginInput",
            target: _i21
          });
        } else {
          var _e32 = this.getSingleInput();

          _t35.appendChild(_e32), this.picker.trigger("view", {
            view: "TimePluginInput",
            target: _e32
          });
        }

        i.appendChild(_t35), this.picker.trigger("view", {
          view: "TimePluginContainer",
          target: _t35
        });
      }
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      var i = e.target;

      if (i instanceof HTMLInputElement && i.classList.contains("time-plugin-input")) {
        var _e33 = this.timePicked[i.name] || new t(),
            _i$value$split = i.value.split(":"),
            _i$value$split2 = _slicedToArray(_i$value$split, 2),
            _n14 = _i$value$split2[0],
            _s11 = _i$value$split2[1];

        _e33.setHours(Number(_n14) || 0, Number(_s11) || 0, 0, 0), this.picker.options.autoApply ? (this.timePicked[i.name] = _e33, this.picker.updateValues()) : this.timePrePicked[i.name] = _e33;
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var i = e.target;

      if (i instanceof HTMLSelectElement && i.classList.contains("time-plugin-custom-input")) {
        var _e34 = /(\w+)\[(\w+)\]/,
            _i$name$match = i.name.match(_e34),
            _i$name$match2 = _slicedToArray(_i$name$match, 3),
            _n15 = _i$name$match2[1],
            _s12 = _i$name$match2[2],
            _o13 = Number(i.value);

        var _a7 = new t();

        switch (!this.picker.options.autoApply && this.timePrePicked[_n15] instanceof Date ? _a7 = this.timePrePicked[_n15].clone() : this.timePicked[_n15] instanceof Date && (_a7 = this.timePicked[_n15].clone()), _s12) {
          case "HH":
            if (this.options.format12) {
              var _t36 = i.closest(".time-plugin-custom-block").querySelector("select[name=\"".concat(_n15, "[period]\"]")).value,
                  _e35 = this.handleFormat12(_t36, _a7, _o13);

              _a7.setHours(_e35.getHours(), _e35.getMinutes(), _e35.getSeconds(), 0);
            } else _a7.setHours(_o13, _a7.getMinutes(), _a7.getSeconds(), 0);

            break;

          case "mm":
            _a7.setHours(_a7.getHours(), _o13, _a7.getSeconds(), 0);

            break;

          case "ss":
            _a7.setHours(_a7.getHours(), _a7.getMinutes(), _o13, 0);

            break;

          case "period":
            if (this.options.format12) {
              var _t37 = i.closest(".time-plugin-custom-block").querySelector("select[name=\"".concat(_n15, "[HH]\"]")).value,
                  _e36 = this.handleFormat12(i.value, _a7, Number(_t37));

              _a7.setHours(_e36.getHours(), _e36.getMinutes(), _e36.getSeconds(), 0);
            }

        }

        if (this.picker.options.autoApply) this.timePicked[_n15] = _a7, this.picker.updateValues();else {
          this.timePrePicked[_n15] = _a7;

          var _t38 = this.picker.ui.container.querySelector(".apply-button");

          if (this.rangePlugin) {
            var _e37 = this.rangePlugin.options,
                _i22 = this.picker.datePicked,
                _n16 = _e37.strict && 2 === _i22.length || !_e37.strict && _i22.length > 0 || !_i22.length && _e37.strict && _e37.startDate instanceof Date && _e37.endDate instanceof Date || !_i22.length && !_e37.strict && (_e37.startDate instanceof Date || _e37.endDate instanceof Date);

            _t38.disabled = !_n16;
          } else this.picker.datePicked.length && (_t38.disabled = !1);
        }
      }
    }
  }, {
    key: "onClick",
    value: function onClick(t) {
      var _this15 = this;

      var e = t.target;

      if (e instanceof HTMLElement) {
        var _t39 = e.closest(".unit");

        if (!(_t39 instanceof HTMLElement)) return;
        this.picker.isApplyButton(_t39) && (Object.keys(this.timePicked).forEach(function (t) {
          _this15.timePrePicked[t] instanceof Date && (_this15.timePicked[t] = _this15.timePrePicked[t].clone());
        }), this.picker.updateValues(), this.timePrePicked = {
          input: null,
          start: null,
          end: null
        }), this.picker.isCancelButton(_t39) && (this.timePrePicked = {
          input: null,
          start: null,
          end: null
        }, this.picker.renderAll());
      }
    }
  }, {
    key: "setTime",
    value: function setTime(t) {
      var e = this.handleTimeString(t);
      this.timePicked.input = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
  }, {
    key: "setStartTime",
    value: function setStartTime(t) {
      var e = this.handleTimeString(t);
      this.timePicked.start = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
  }, {
    key: "setEndTime",
    value: function setEndTime(t) {
      var e = this.handleTimeString(t);
      this.timePicked.end = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
  }, {
    key: "handleTimeString",
    value: function handleTimeString(e) {
      var i = new t(),
          _e$split$map = e.split(":").map(function (t) {
        return Number(t);
      }),
          _e$split$map2 = _slicedToArray(_e$split$map, 3),
          n = _e$split$map2[0],
          s = _e$split$map2[1],
          o = _e$split$map2[2],
          a = n && !Number.isNaN(n) ? n : 0,
          r = s && !Number.isNaN(s) ? s : 0,
          c = o && !Number.isNaN(o) ? o : 0;

      return i.setHours(a, r, c, 0), i;
    }
  }, {
    key: "getDate",
    value: function getDate() {
      if (this.picker.options.date instanceof Date) {
        var _e38 = new t(this.picker.options.date, this.picker.options.format);

        if (this.timePicked.input instanceof Date) {
          var _t40 = this.timePicked.input;

          _e38.setHours(_t40.getHours(), _t40.getMinutes(), _t40.getSeconds(), 0);
        }

        return _e38;
      }

      return null;
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      if (this.rangePlugin.options.startDate instanceof Date) {
        var _e39 = new t(this.rangePlugin.options.startDate, this.picker.options.format);

        if (this.timePicked.start instanceof Date) {
          var _t41 = this.timePicked.start;

          _e39.setHours(_t41.getHours(), _t41.getMinutes(), _t41.getSeconds(), 0);
        }

        return _e39;
      }

      return null;
    }
  }, {
    key: "getEndDate",
    value: function getEndDate() {
      if (this.rangePlugin.options.endDate instanceof Date) {
        var _e40 = new t(this.rangePlugin.options.endDate, this.picker.options.format);

        if (this.timePicked.end instanceof Date) {
          var _t42 = this.timePicked.end;

          _e40.setHours(_t42.getHours(), _t42.getMinutes(), _t42.getSeconds(), 0);
        }

        return _e40;
      }

      return null;
    }
  }, {
    key: "getSingleInput",
    value: function getSingleInput() {
      return this.options.native ? this.getNativeInput("input") : this.getCustomInput("input");
    }
  }, {
    key: "getStartInput",
    value: function getStartInput() {
      return this.options.native ? this.getNativeInput("start") : this.getCustomInput("start");
    }
  }, {
    key: "getEndInput",
    value: function getEndInput() {
      return this.options.native ? this.getNativeInput("end") : this.getCustomInput("end");
    }
  }, {
    key: "getNativeInput",
    value: function getNativeInput(t) {
      var e = document.createElement("input");
      e.type = "time", e.name = t, e.className = "time-plugin-input unit";
      var i = this.timePicked[t];

      if (i) {
        var _t43 = "0".concat(i.getHours()).slice(-2),
            _n17 = "0".concat(i.getMinutes()).slice(-2);

        e.value = "".concat(_t43, ":").concat(_n17);
      }

      return e;
    }
  }, {
    key: "getCustomInput",
    value: function getCustomInput(t) {
      var e = document.createElement("div");
      e.className = "time-plugin-custom-block";
      var i = document.createElement("select");
      i.className = "time-plugin-custom-input unit", i.name = "".concat(t, "[HH]");
      var n = this.options.format12 ? 1 : 0,
          s = this.options.format12 ? 13 : 24;
      var o = null;
      !this.picker.options.autoApply && this.timePrePicked[t] instanceof Date ? o = this.timePrePicked[t].clone() : this.timePicked[t] instanceof Date && (o = this.timePicked[t].clone());

      for (var _t44 = n; _t44 < s; _t44 += this.options.stepHours) {
        var _e41 = document.createElement("option");

        _e41.value = String(_t44), _e41.text = String(_t44), o && (this.options.format12 ? (o.getHours() % 12 ? o.getHours() % 12 : 12) === _t44 && (_e41.selected = !0) : o.getHours() === _t44 && (_e41.selected = !0)), i.appendChild(_e41);
      }

      e.appendChild(i);
      var a = document.createElement("select");
      a.className = "time-plugin-custom-input unit", a.name = "".concat(t, "[mm]");

      for (var _t45 = 0; _t45 < 60; _t45 += this.options.stepMinutes) {
        var _e42 = document.createElement("option");

        _e42.value = "0".concat(String(_t45)).slice(-2), _e42.text = "0".concat(String(_t45)).slice(-2), o && o.getMinutes() === _t45 && (_e42.selected = !0), a.appendChild(_e42);
      }

      if (e.appendChild(a), this.options.seconds) {
        var _i23 = document.createElement("select");

        _i23.className = "time-plugin-custom-input unit", _i23.name = "".concat(t, "[ss]");
        var _n18 = 60;

        for (var _t46 = 0; _t46 < _n18; _t46 += this.options.stepSeconds) {
          var _e43 = document.createElement("option");

          _e43.value = "0".concat(String(_t46)).slice(-2), _e43.text = "0".concat(String(_t46)).slice(-2), o && o.getSeconds() === _t46 && (_e43.selected = !0), _i23.appendChild(_e43);
        }

        e.appendChild(_i23);
      }

      if (this.options.format12) {
        var _i24 = document.createElement("select");

        _i24.className = "time-plugin-custom-input unit", _i24.name = "".concat(t, "[period]"), ["AM", "PM"].forEach(function (t) {
          var e = document.createElement("option");
          e.value = t, e.text = t, o && "PM" === t && o.getHours() >= 12 && (e.selected = !0), _i24.appendChild(e);
        }), e.appendChild(_i24);
      }

      return e;
    }
  }, {
    key: "handleFormat12",
    value: function handleFormat12(t, e, i) {
      var n = e.clone();

      switch (t) {
        case "AM":
          12 === i ? n.setHours(0, n.getMinutes(), n.getSeconds(), 0) : n.setHours(i, n.getMinutes(), n.getSeconds(), 0);
          break;

        case "PM":
          12 !== i ? n.setHours(i + 12, n.getMinutes(), n.getSeconds(), 0) : n.setHours(i, n.getMinutes(), n.getSeconds(), 0);
      }

      return n;
    }
  }, {
    key: "parseValues",
    value: function parseValues() {
      if (this.rangePlugin) {
        if (this.rangePlugin.options.strict) {
          if (this.rangePlugin.options.startDate && this.rangePlugin.options.endDate) {
            var _e44 = new t(this.rangePlugin.options.startDate, this.picker.options.format),
                _i25 = new t(this.rangePlugin.options.endDate, this.picker.options.format);

            this.timePicked.start = _e44.clone(), this.timePicked.end = _i25.clone();
          }
        } else {
          if (this.rangePlugin.options.startDate) {
            var _e45 = new t(this.rangePlugin.options.startDate, this.picker.options.format);

            this.timePicked.start = _e45.clone();
          }

          if (this.rangePlugin.options.endDate) {
            var _e46 = new t(this.rangePlugin.options.endDate, this.picker.options.format);

            this.timePicked.end = _e46.clone();
          }
        }

        if (this.rangePlugin.options.elementEnd) {
          if (this.rangePlugin.options.strict) {
            if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.rangePlugin.options.elementEnd instanceof HTMLInputElement && this.rangePlugin.options.elementEnd.value.length) {
              var _e47 = new t(this.picker.options.element.value, this.picker.options.format),
                  _i26 = new t(this.rangePlugin.options.elementEnd.value, this.picker.options.format);

              this.timePicked.start = _e47.clone(), this.timePicked.end = _i26.clone();
            }
          } else {
            if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
              var _e48 = new t(this.picker.options.element.value, this.picker.options.format);

              this.timePicked.start = _e48.clone();
            }

            if (this.rangePlugin.options.elementEnd instanceof HTMLInputElement && this.rangePlugin.options.elementEnd.value.length) {
              var _e49 = new t(this.rangePlugin.options.elementEnd.value, this.picker.options.format);

              this.timePicked.start = _e49.clone();
            }
          }
        } else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
          var _this$picker$options$3 = this.picker.options.element.value.split(this.rangePlugin.options.delimiter),
              _this$picker$options$4 = _slicedToArray(_this$picker$options$3, 2),
              _e50 = _this$picker$options$4[0],
              _i27 = _this$picker$options$4[1];

          if (this.rangePlugin.options.strict) {
            if (_e50 && _i27) {
              var _n19 = new t(_e50, this.picker.options.format),
                  _s13 = new t(_i27, this.picker.options.format);

              this.timePicked.start = _n19.clone(), this.timePicked.end = _s13.clone();
            }
          } else {
            if (_e50) {
              var _i28 = new t(_e50, this.picker.options.format);

              this.timePicked.start = _i28.clone();
            }

            if (_i27) {
              var _e51 = new t(_i27, this.picker.options.format);

              this.timePicked.start = _e51.clone();
            }
          }
        }
      } else {
        if (this.picker.options.date) {
          var _e52 = new t(this.picker.options.date, this.picker.options.format);

          this.timePicked.input = _e52.clone();
        }

        if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
          var _e53 = new t(this.picker.options.element.value, this.picker.options.format);

          this.timePicked.input = _e53.clone();
        }
      }
    }
  }]);

  return l;
}(o);

var h = /*#__PURE__*/function (_o14) {
  _inherits(h, _o14);

  var _super6 = _createSuper(h);

  function h() {
    var _this16;

    _classCallCheck(this, h);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this16 = _super6.call.apply(_super6, [this].concat(args));
    _this16.docElement = null;
    _this16.rangePlugin = void 0;
    _this16.binds = {
      onView: _this16.onView.bind(_assertThisInitialized(_this16)),
      onKeydown: _this16.onKeydown.bind(_assertThisInitialized(_this16))
    };
    _this16.options = {
      unitIndex: 1,
      dayIndex: 2
    };
    return _this16;
  }

  _createClass(h, [{
    key: "getName",
    value: function getName() {
      return "KbdPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      var _this17 = this;

      var t = this.picker.options.element,
          e = t.getBoundingClientRect();
      if (this.docElement = document.createElement("span"), this.docElement.style.position = "absolute", this.docElement.style.top = "".concat(t.offsetTop, "px"), this.docElement.style.left = t.offsetLeft + e.width - 25 + "px", this.docElement.attachShadow({
        mode: "open"
      }), this.options.html) this.docElement.shadowRoot.innerHTML = this.options.html;else {
        var _t47 = "\n      <style>\n      button {\n        border: none;\n        background: transparent;\n        font-size: ".concat(window.getComputedStyle(this.picker.options.element).fontSize, ";\n      }\n      </style>\n\n      <button>&#128197;</button>\n      ");

        this.docElement.shadowRoot.innerHTML = _t47;
      }
      var i = this.docElement.shadowRoot.querySelector("button");
      i && (i.addEventListener("click", function (t) {
        t.preventDefault(), _this17.picker.show({
          target: _this17.picker.options.element
        });
      }, {
        capture: !0
      }), i.addEventListener("keydown", function (t) {
        "Escape" === t.code && _this17.picker.hide();
      }, {
        capture: !0
      })), this.picker.options.element.after(this.docElement), this.picker.on("view", this.binds.onView), this.picker.on("keydown", this.binds.onKeydown);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.docElement && this.docElement.isConnected && this.docElement.remove(), this.picker.off("view", this.binds.onView), this.picker.off("keydown", this.binds.onKeydown);
    }
  }, {
    key: "onView",
    value: function onView(t) {
      var _this18 = this;

      var _t$detail5 = t.detail,
          e = _t$detail5.view,
          i = _t$detail5.target;
      i && "querySelector" in i && ("CalendarDay" !== e || ["locked", "not-available"].some(function (t) {
        return i.classList.contains(t);
      }) ? _toConsumableArray(i.querySelectorAll(".unit:not(.day)")).forEach(function (t) {
        return t.tabIndex = _this18.options.unitIndex;
      }) : i.tabIndex = this.options.dayIndex);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(t) {
      switch (this.onMouseEnter(t), t.code) {
        case "ArrowUp":
        case "ArrowDown":
          this.verticalMove(t);
          break;

        case "ArrowLeft":
        case "ArrowRight":
          this.horizontalMove(t);
          break;

        case "Enter":
        case "Space":
          this.handleEnter(t);
          break;

        case "Escape":
          this.picker.hide();
      }
    }
  }, {
    key: "findAllowableDaySibling",
    value: function findAllowableDaySibling(t, e, i) {
      var _this19 = this;

      var n = Array.from(t.querySelectorAll(".day[tabindex=\"".concat(this.options.dayIndex, "\"]"))),
          s = n.indexOf(e);
      return n.filter(function (t, e) {
        return i(e, s) && t.tabIndex === _this19.options.dayIndex;
      })[0];
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(t) {
      var _this20 = this;

      var e = {
        ArrowLeft: "previous",
        ArrowRight: "next"
      },
          i = this.picker.ui.container.querySelector(".".concat(e[t.code], "-button[tabindex=\"").concat(this.options.unitIndex, "\"]"));
      i && !i.parentElement.classList.contains("no-".concat(e[t.code], "-month")) && (i.dispatchEvent(new Event("click", {
        bubbles: !0
      })), setTimeout(function () {
        var e = null;

        switch (t.code) {
          case "ArrowLeft":
            var _t48 = _this20.picker.ui.container.querySelectorAll(".day[tabindex=\"".concat(_this20.options.dayIndex, "\"]"));

            e = _t48[_t48.length - 1];
            break;

          case "ArrowRight":
            e = _this20.picker.ui.container.querySelector(".day[tabindex=\"".concat(_this20.options.dayIndex, "\"]"));
        }

        e && e.focus();
      }));
    }
  }, {
    key: "verticalMove",
    value: function verticalMove(t) {
      var e = t.target;

      if (e.classList.contains("day")) {
        t.preventDefault();

        var _i29 = this.findAllowableDaySibling(this.picker.ui.container, e, function (e, i) {
          return e === ("ArrowUp" === t.code ? i - 7 : i + 7);
        });

        _i29 && _i29.focus();
      }
    }
  }, {
    key: "horizontalMove",
    value: function horizontalMove(t) {
      var e = t.target;

      if (e.classList.contains("day")) {
        t.preventDefault();

        var _i30 = this.findAllowableDaySibling(this.picker.ui.container, e, function (e, i) {
          return e === ("ArrowLeft" === t.code ? i - 1 : i + 1);
        });

        _i30 ? _i30.focus() : this.changeMonth(t);
      }
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(t) {
      var _this21 = this;

      var e = t.target;
      e.classList.contains("day") && (t.preventDefault(), e.dispatchEvent(new Event("click", {
        bubbles: !0
      })), setTimeout(function () {
        if (_this21.rangePlugin = _this21.picker.PluginManager.getInstance("RangePlugin"), _this21.rangePlugin || !_this21.picker.options.autoApply) {
          var _t49 = _this21.picker.ui.container.querySelector(".day.selected");

          _t49 && setTimeout(function () {
            _t49.focus();
          });
        }
      }));
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(t) {
      var _this22 = this;

      t.target.classList.contains("day") && setTimeout(function () {
        var t = _this22.picker.ui.shadowRoot.activeElement;
        t && t.dispatchEvent(new Event("mouseenter", {
          bubbles: !0
        }));
      });
    }
  }]);

  return h;
}(o);

var d = /*#__PURE__*/function (_o15) {
  _inherits(d, _o15);

  var _super7 = _createSuper(d);

  function d() {
    var _this23;

    _classCallCheck(this, d);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this23 = _super7.call.apply(_super7, [this].concat(args));
    _this23.rangePlugin = void 0;
    _this23.lockPlugin = void 0;
    _this23.priority = 10;
    _this23.binds = {
      onView: _this23.onView.bind(_assertThisInitialized(_this23)),
      onColorScheme: _this23.onColorScheme.bind(_assertThisInitialized(_this23))
    };
    _this23.options = {
      dropdown: {
        months: !1,
        years: !1,
        minYear: 1950,
        maxYear: null
      },
      darkMode: !0,
      locale: {
        resetButton: '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>'
      }
    };
    _this23.matchMedia = void 0;
    return _this23;
  }

  _createClass(d, [{
    key: "getName",
    value: function getName() {
      return "AmpPlugin";
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.options.darkMode && window && "matchMedia" in window && (this.matchMedia = window.matchMedia("(prefers-color-scheme: dark)"), this.matchMedia.matches && (this.picker.ui.container.dataset.theme = "dark"), this.matchMedia.addEventListener("change", this.binds.onColorScheme)), this.options.weekNumbers && this.picker.ui.container.classList.add("week-numbers"), this.picker.on("view", this.binds.onView);
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.options.darkMode && window && "matchMedia" in window && this.matchMedia.removeEventListener("change", this.binds.onColorScheme), this.picker.ui.container.removeAttribute("data-theme"), this.picker.ui.container.classList.remove("week-numbers"), this.picker.off("view", this.binds.onView);
    }
  }, {
    key: "onView",
    value: function onView(t) {
      this.lockPlugin = this.picker.PluginManager.getInstance("LockPlugin"), this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.handleDropdown(t), this.handleResetButton(t), this.handleWeekNumbers(t);
    }
  }, {
    key: "onColorScheme",
    value: function onColorScheme(t) {
      var e = t.matches ? "dark" : "light";
      this.picker.ui.container.dataset.theme = e;
    }
  }, {
    key: "handleDropdown",
    value: function handleDropdown(e) {
      var _this24 = this;

      var _e$detail3 = e.detail,
          i = _e$detail3.view,
          n = _e$detail3.target,
          s = _e$detail3.date,
          o = _e$detail3.index;

      if ("CalendarHeader" === i) {
        var _e54 = n.querySelector(".month-name");

        if (this.options.dropdown.months) {
          _e54.childNodes[0].remove();

          var _i31 = document.createElement("select");

          _i31.className = "month-name--select month-name--dropdown";

          for (var _e55 = 0; _e55 < 12; _e55 += 1) {
            var _n20 = document.createElement("option"),
                _o16 = new t(new Date(s.getFullYear(), _e55, 2, 0, 0, 0)),
                _a8 = new t(new Date(s.getFullYear(), _e55, 1, 0, 0, 0));

            _n20.value = String(_e55), _n20.text = _o16.toLocaleString(this.picker.options.lang, {
              month: "long"
            }), this.lockPlugin && (_n20.disabled = this.lockPlugin.options.minDate && _a8.isBefore(new t(this.lockPlugin.options.minDate), "month") || this.lockPlugin.options.maxDate && _a8.isAfter(new t(this.lockPlugin.options.maxDate), "month")), _n20.selected = _a8.getMonth() === s.getMonth(), _i31.appendChild(_n20);
          }

          _i31.addEventListener("change", function (t) {
            var e = t.target;
            _this24.picker.calendars[0].setDate(1), _this24.picker.calendars[0].setMonth(Number(e.value)), _this24.picker.renderAll();
          }), _e54.prepend(_i31);
        }

        if (this.options.dropdown.years) {
          _e54.childNodes[1].remove();

          var _i32 = document.createElement("select");

          _i32.className = "month-name--select";

          var _n21 = this.options.dropdown.minYear,
              _o17 = this.options.dropdown.maxYear ? this.options.dropdown.maxYear : new Date().getFullYear();

          if (s.getFullYear() > _o17) {
            var _t50 = document.createElement("option");

            _t50.value = String(s.getFullYear()), _t50.text = String(s.getFullYear()), _t50.selected = !0, _t50.disabled = !0, _i32.appendChild(_t50);
          }

          for (var _e56 = _o17; _e56 >= _n21; _e56 -= 1) {
            var _n22 = document.createElement("option"),
                _o18 = new t(new Date(_e56, 0, 1, 0, 0, 0));

            _n22.value = String(_e56), _n22.text = String(_e56), this.lockPlugin && (_n22.disabled = this.lockPlugin.options.minDate && _o18.isBefore(new t(this.lockPlugin.options.minDate), "year") || this.lockPlugin.options.maxDate && _o18.isAfter(new t(this.lockPlugin.options.maxDate), "year")), _n22.selected = s.getFullYear() === _e56, _i32.appendChild(_n22);
          }

          if (s.getFullYear() < _n21) {
            var _t51 = document.createElement("option");

            _t51.value = String(s.getFullYear()), _t51.text = String(s.getFullYear()), _t51.selected = !0, _t51.disabled = !0, _i32.appendChild(_t51);
          }

          if ("asc" === this.options.dropdown.years) {
            var _t52 = Array.prototype.slice.call(_i32.childNodes).reverse();

            _i32.innerHTML = "", _t52.forEach(function (t) {
              t.innerHTML = t.value, _i32.appendChild(t);
            });
          }

          _i32.addEventListener("change", function (t) {
            var e = t.target;
            _this24.picker.calendars[0].setFullYear(Number(e.value)), _this24.picker.renderAll();
          }), _e54.appendChild(_i32);
        }
      }
    }
  }, {
    key: "handleResetButton",
    value: function handleResetButton(t) {
      var _this25 = this;

      var _t$detail6 = t.detail,
          e = _t$detail6.view,
          i = _t$detail6.target;

      if ("CalendarHeader" === e && this.options.resetButton) {
        var _t53 = document.createElement("button");

        _t53.className = "reset-button unit", _t53.innerHTML = this.options.locale.resetButton, _t53.addEventListener("click", function (t) {
          t.preventDefault();
          var e = !0;
          "function" == typeof _this25.options.resetButton && (e = _this25.options.resetButton.call(_this25)), e && _this25.picker.clear();
        }), i.appendChild(_t53);
      }
    }
  }, {
    key: "handleWeekNumbers",
    value: function handleWeekNumbers(e) {
      var _this26 = this;

      if (this.options.weekNumbers) {
        var _e$detail4 = e.detail,
            _i33 = _e$detail4.view,
            _n23 = _e$detail4.target;

        if ("CalendarDayNames" === _i33) {
          var _t54 = document.createElement("div");

          _t54.className = "wnum-header", _t54.innerHTML = "Wk", _n23.prepend(_t54);
        }

        "CalendarDays" === _i33 && _toConsumableArray(_n23.children).forEach(function (e, i) {
          if (0 === i || i % 7 == 0) {
            var _i34;

            if (e.classList.contains("day")) _i34 = new t(e.dataset.time);else {
              var _e57 = _n23.querySelector(".day");

              _i34 = new t(_e57.dataset.time);
            }

            var _s14 = _i34.getWeek(_this26.picker.options.firstDay);

            53 === _s14 && 0 === _i34.getMonth() && (_s14 = "53/1");

            var _o19 = document.createElement("div");

            _o19.className = "wnum-item", _o19.innerHTML = String(_s14), _n23.insertBefore(_o19, e);
          }
        });
      }
    }
  }]);

  return d;
}(o);

export { d as AmpPlugin, t as DateTime, h as KbdPlugin, a as LockPlugin, r as PresetPlugin, c as RangePlugin, l as TimePlugin, n as create, s as easepick };